// Shared display formatting. Use these instead of toFixed()/hand-built Intl formatters in pages.
export {formatLocalDate, formatLocalDateTime} from "./Pages/Admin/adminDateFormat";
export {humanizeEnumValue} from "./i18n/labelHelpers";

const moneyLocales: Record<string, string> = {
    en: "en-US",
    de: "de-DE",
    it: "it-IT"
};

const resolveMoneyLocale = (language?: string | null) =>
    moneyLocales[(language ?? "").slice(0, 2).toLowerCase()] ?? "hr-HR";

const toFiniteNumber = (value: unknown): number | null => {
    const numericValue = typeof value === "number" ? value : Number.parseFloat(String(value ?? ""));
    return Number.isFinite(numericValue) ? numericValue : null;
};

// 1234.5 -> "1.234,50 €" (hr) or "€1,234.50" (en).
export const formatMoney = (
    value: unknown,
    currency?: string | null,
    language?: string | null,
    emptyValue = "-"
): string => {
    const numericValue = toFiniteNumber(value);

    if (numericValue === null) {
        return emptyValue;
    }

    return new Intl.NumberFormat(resolveMoneyLocale(language), {
        style: "currency",
        currency: currency?.trim() || "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numericValue);
};
